import L from "leaflet";

let prevClick: any;

export const createGeoJSONConfig = ({
  mapRef,
  geoJsonRef,
  infoRef,
}: {
  mapRef: React.MutableRefObject<L.Map | undefined>;
  geoJsonRef: React.MutableRefObject<any>;
  infoRef?: any;
}) => {
  const hasInfo = infoRef && infoRef.current;

  const resetHighlight = (e: any) => {
    geoJsonRef.current.resetStyle(e.target);
  };

  const zoomToFeature = (e: any) => {
    if (mapRef.current) mapRef.current.fitBounds(e.target.getBounds());
  };

  const highlightFeature = ({ target }: any) => {
    if (prevClick) {
      geoJsonRef.current.resetStyle(prevClick);
    }
    prevClick = target;
    target.setStyle({
      weight: 1,
      fillOpacity: 1,
    });
  };

  const setInfo = ({ target: { feature } }: any) => {
    if (hasInfo) {
      infoRef.current.update(feature.properties);
    }
  };

  const onClick = (e: any) => {
    zoomToFeature(e);
    setInfo(e);
    highlightFeature(e);
  };

  const onMouseIn = (e: any) => {
    highlightFeature(e);
  };

  const onMouseOut = (e: any) => {
    resetHighlight(e);
  };

  return {
    onClick,
    onMouseIn,
    onMouseOut,
  };
};
